import { render, staticRenderFns } from "./BulletinCard.vue?vue&type=template&id=5c3c0201&scoped=true&"
import script from "./BulletinCard.vue?vue&type=script&lang=js&"
export * from "./BulletinCard.vue?vue&type=script&lang=js&"
import style0 from "./BulletinCard.vue?vue&type=style&index=0&id=5c3c0201&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c0201",
  null
  
)

export default component.exports